export default __webpack_public_path__ + "static/media/roboto-vietnamese-400-normal.c0bec65d.woff2";